import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from '../';

import { BankUpdateForm } from './BankUpdateForm';

export class WithdrawalBankChangeModal extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    targetBankaccountId: PropTypes.string,
    withdrawableTargetBankaccounts: PropTypes.string.isRequired,
    onCancelClick: PropTypes.func.isRequired,
    onSaveClick: PropTypes.func.isRequired,
  };

  static defaultProps = {
    title: 'Change withdrawal bank account',
  };

  render() {
    const {
      title,
      targetBankaccountId,
      withdrawableTargetBankaccounts,
      onCancelClick,
      onSaveClick,
    } = this.props;

    return (
      <Modal
        heading={title}
        body={
          <BankUpdateForm
            targetBankaccountId={targetBankaccountId}
            withdrawableTargetBankaccounts={JSON.parse(withdrawableTargetBankaccounts)}
            onCancelClick={onCancelClick}
            onSaveClick={onSaveClick}
          />
        }
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/withdrawal-bank-change-modal/index.js